<div fxLayout="column">
  <p>Logging you out</p>
  <mat-progress-spinner
    color="primary"
    diameter="30"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
